var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand"},[_vm._v(" - 医精德诚，廉洁在心 - ")])
}
var staticRenderFns = []

export { render, staticRenderFns }